import colors from 'assets/theme/base/colors';
import typography from 'assets/theme/base/typography';

const { size, fontWeightRegular } = typography;

const formHelperText = {
    styleOverrides: {
        root: {
            fontSize: size.sm,
            fontWeight: fontWeightRegular,
            color: colors.error.main,
        },
    },
};

export default formHelperText;
